import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TemplateItem from './TemplateItem';
import {
  asyncFetchTemplates,
  asyncSearchForTemplates,
  preloadTemplate,
  resetSettings,
  changeOrder
} from 'actions/templates';
import * as Const from 'util/constants';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './TemplateList.scss';

export class TemplateList extends Component {
  static propTypes = {
    templates: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    hasMore: PropTypes.bool.isRequired,
    fetchTemplates: PropTypes.func.isRequired,
    clearList: PropTypes.bool,
    orderBy: PropTypes.string,
    initQuery: PropTypes.string
  };

  componentDidMount() {
    // load templates data when navigating from URL
    const { isLoading, searchForTemplates, clearList, reset, orderBy, order, initQuery } = this.props;

    if (!isLoading) {
      if (clearList) {
        reset();
      }
      if (orderBy) {
        order(orderBy);
      }
      searchForTemplates(initQuery, Const.TYPE_TEMPLATES);
    }
  }

  more = () => {
    const { isLoading, fetchTemplates } = this.props;
    if (!isLoading) {
      fetchTemplates(true);
    }
  };

  render() {
    const { templates, isLoading, hasMore, loadTemplate } = this.props;
    return (
      <div className="template-list d-flex flex-column">
        <div className="d-flex flex-wrap">
          {templates && templates.length > 0
            ? templates.map((template, i) => (
                <TemplateItem key={i} template={template} className="col-md-6 col-lg-4" onSelect={loadTemplate} />
              ))
            : !isLoading && <p className="p-4">No template found matching your criteria.</p>}
          {isLoading && (
            <div className="loading">
              <i className="fas fa-spinner fa-spin" />
            </div>
          )}
        </div>
        {templates && templates.length > 0 && hasMore && (
          <button className="btn btn-clear align-self-center" onClick={this.more}>
            View more
          </button>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { list, isLoading, hasMore } = state.templates;
  return {
    templates: list,
    isLoading,
    hasMore
  };
};

const mapDispatchToProps = dispatch => ({
  reset: () => dispatch(resetSettings()),
  order: orderBy => dispatch(changeOrder(orderBy)),
  fetchTemplates: more => dispatch(asyncFetchTemplates(more)),
  searchForTemplates: (term, type) => dispatch(asyncSearchForTemplates(term, type)),
  loadTemplate: template => dispatch(preloadTemplate(template))
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateList);
